import React from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { history } from 'store/configureStore';
import SortTable from 'components/parts/item/sortTable';
import Setting from 'components/srv/setting/setting';
import { getProgramSettings } from 'actions/programSettingAction';
import { setMessage, clearMessage } from 'actions/messageAction';
import { setLoading, clearLoading } from 'actions/loadingAction';
import { lang } from 'lang';
import { createUniqueStr, consoleLogger } from 'helpers';

/**
 * 調整プログラム設定をテーブルで表示するコンポーネント
 */
const SettingList = () => {
  const { msg, error } = lang;
  const dispatch = useDispatch();
  // グローバルステートから調整プログラム設定を取得する
  const srvSettingState = useSelector((state) => state.programSetting);  
  // リクエストキャンセルトークンを取得
  const cancelToken = axios.CancelToken.source();

  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => {
    // メッセージを初期化
    dispatch(clearMessage());
    getData(cancelToken);
    return () => { cancelToken.cancel('unmounted component.'); };
  },[]);

  // 調整プログラム設定を一覧取得する
  const getData = async (cancelToken) => {   
    try {
      dispatch(setLoading('unit'));
      await dispatch(
        await getProgramSettings(cancelToken)
      ).then((result) => {
        // Success
        if (result.status === 200) {
          // 他の画面から渡されたメッセージをセットする(登録・編集)
          if (history.location.state && history.location.state.message && history.location.state.message.type && history.location.state.message.msg) {
            const { type, msg } = history.location.state.message;
            // メッセージをセット
            dispatch(setMessage(type, msg));
            // ヒストリーの初期化
            history.replace({pathname: '/srv/settings', state: {}});
          // Not exist
          } else if (result.count === 0) {
            dispatch(setMessage('info', msg.custom_file.not_found));
          }
        // Error
        } else {
          dispatch(setMessage('danger', error.custom_file.gets + `\n${result.errcode}`));
        }
      });
      dispatch(clearLoading());
    } catch (e) {
      consoleLogger('Fail get program setting list.', e);
    }
  }; 
  // オプション設定
  const options = {
    sort: true,              // ソート機能を有効にする
    sort_key: 'product_cd' // 初期表示で昇順にソートするキーを指定
  };
  // テーブルヘッダー定義
  const headers = { items: [], operations: {total: 2} };  //操作カラム数 = 2
  headers.items = [
    { attribute: {}, sort: { key: 'product_cd', isAsc: true }, name: 'Product code'},
    { attribute: {}, sort: { key: 'destination' }, name: 'Region'},
    { attribute: {}, sort: { key: 'model' }, name: 'Product name'},
    { attribute: {}, sort: { key: 'alias' }, name: 'Name'},
    { attribute: {}, sort: { key: 'filename' }, name: 'File name'},
    { attribute: {}, sort: { key: 'updated_at' }, name: 'Last update', style: {width: 170}},
  ];  
  return (
    <>
      {<SortTable headers={headers} state={{status: createUniqueStr(), items: srvSettingState.items}} options={options} component={Setting}/>}
    </>
  );
};
export default SettingList;
